export default __webpack_public_path__ + "static/media/donation-nyps.39a0db26.png";